import m from "./design-system.es883.js";
import o from "./design-system.es929.js";
import u from "./design-system.es936.js";
function b(e, n, r) {
  if (n = n || {}, r = new m(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return u(e, n, r.metadata) !== void 0;
  var l = n.v2 ? e.nationalNumber : e.phone;
  return o(l, r.nationalNumberPattern());
}
export {
  b as default
};
//# sourceMappingURL=design-system.es935.js.map
